/**
 * SYNC NOTE: This file has an intentional mirror copy in:
 *   apps/feature-upgrade-dialog/src/js/FeatureUpgradeDialog/utils/normalizeUpgradePromotion.js
 *
 * The two apps are independent nx projects with no cross-package import path.
 * Any change to this function MUST be applied to both copies.
 *
 * Normalizes a raw /upgradeplan/promotion API response into the shape that
 * useInitPlanBlocks and setUpgradeInfo expect.
 *
 * The endpoint may use different field names depending on the upgrade path:
 *   - Legacy → V21:  currentPlanGroupId / recommendedPlanGroupId / recommendedPlanId  (standard)
 *   - Micro Email → 3PL: planGroupId / recommended3PlPlanGroupId / recommended3PlPlanId  (alternate keys)
 *
 * This function normalises both shapes into the standard keys so downstream
 * consumers don't need to handle both variants.
 *
 * @param {object} promotion - Raw promotion response from the API
 * @returns {object} Normalized promotion with standard field names
 */
export function normalizeUpgradePromotion(promotion) {
  return {
    ...promotion,
    currentPlanGroupId: promotion.currentPlanGroupId ?? promotion.planGroupId,
    recommendedPlanGroupId: promotion.recommendedPlanGroupId ?? promotion.recommended3PlPlanGroupId,
    recommendedPlanId: promotion.recommendedPlanId ?? promotion.recommended3PlPlanId,
  };
}
